import angular from 'angular';
import emailBodyField from './emailBodyField';
import './style.scss';

export default angular
  .module('emailBodyField', [])
  .component('emailBodyField', emailBodyField).name;
